import Vmasker from 'vanilla-masker';
import { removeEspacos, removeTodasMascaras } from './stringFormatter';

export const cepMask = value => {
  if (!value) return value;
  return Vmasker.toPattern(removeTodasMascaras(value), '99999-999');
};
export const cpfMask = value => {
  if (!value) return value;
  return Vmasker.toPattern(removeTodasMascaras(value), '999.999.999-99');
};
export const cnpjMask = value => {
  if (!value) return value;
  return Vmasker.toPattern(removeTodasMascaras(value), '99.999.999/9999-99');
};
export const documentoMask = value => {
  if (removeTodasMascaras(value)?.length > 11) return cnpjMask(value);
  return cpfMask(value);
};

export const telefoneMask = value => {
  if (!value) return value;
  const newValue = removeEspacos(removeTodasMascaras(value));
  if (newValue?.length <= 10) return Vmasker.toPattern(newValue, '(99) 9999-9999');
  return Vmasker.toPattern(newValue, '(99) 9 9999-9999');
};

export const inscricaoMunicipalMask = value => {
  if (!value) return value;
  return Vmasker.toPattern(removeTodasMascaras(value), '999.999/999-99');
};
export const inscricaoEstadualMask = value => {
  if (!value) return value;
  return Vmasker.toPattern(removeTodasMascaras(value), '999999-99');
};

export const documentoMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (removeTodasMascaras(value)?.length > 11) return cnpjMaskView(value);
  return cpfMaskView(value);
};
export const cpfMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (!value) return value;
  return cpfMask(removeTodasMascaras(value)?.padStart(11, '0'));
};
export const cnpjMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (!value) return value;
  return cnpjMask(removeTodasMascaras(value)?.padStart(14, '0'));
};
export const cepMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (!value) return value;
  return cepMask(removeTodasMascaras(value)?.padStart(8, '0'));
};
export const inscricaoMunicipalMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (!value) return value;
  return inscricaoMunicipalMask(removeTodasMascaras(value)?.padStart(11, '0'));
};
export const inscricaoEstadualMaskView = value => {
  // USAR SOMENTE NO DETALHAR
  if (!value) return value;
  return inscricaoEstadualMask(removeTodasMascaras(value)?.padStart(8, '0'));
};
